import { api } from '@orisini/ui/lib/api'

/** Klien topik & Discover (orisini-studio lewat /api/studio/*). */

export interface TopicRun {
  status: 'running' | 'done' | 'failed'
  scanned: number
  candidates: number
  added: number
  usedAi: boolean
  error: string | null
  at: number
}

export interface Topic {
  id: string
  workspaceId: string
  name: string
  keywords: string
  excludeKeywords: string
  instructions: string
  active: boolean
  newItems: number
  lastRun: TopicRun | null
  createdAt: number
}

export type TopicInput = Pick<Topic, 'name' | 'keywords' | 'excludeKeywords' | 'instructions' | 'active'>

export type DiscoverStatus = 'new' | 'selected' | 'ignored'

export interface DiscoverItem {
  id: string
  workspaceId: string
  workspaceName: string
  topicId: string | null
  topicName: string | null
  url: string
  title: string
  excerpt: string | null
  imageUrl: string | null
  sourceName: string | null
  publishedAt: number | null
  score: number
  summary: string | null
  angle: string | null
  usedAi: boolean
  status: DiscoverStatus
  foundAt: number
}

const base = '/studio'

export const discoverApi = {
  topics: (workspaceId: string) =>
    api.get<{ topics: Topic[] }>(`${base}/workspaces/${workspaceId}/topics`).then((r) => r.topics),
  createTopic: (workspaceId: string, input: TopicInput) =>
    api.post<{ topic: Topic }>(`${base}/workspaces/${workspaceId}/topics`, input).then((r) => r.topic),
  updateTopic: (id: string, input: Partial<TopicInput>) =>
    api.patch<{ topic: Topic }>(`${base}/topics/${id}`, input).then((r) => r.topic),
  deleteTopic: (id: string) => api.delete(`${base}/topics/${id}`),
  runTopic: (id: string) =>
    api.post<{ topic: Topic; outcome: { status: string; added: number; candidates: number; scanned: number; usedAi: boolean; error?: string } }>(
      `${base}/topics/${id}/run`,
      {},
    ),

  list: (status: DiscoverStatus, workspaceId?: string) =>
    api.get<{ items: DiscoverItem[]; counts: Record<DiscoverStatus, number> }>(
      `${base}/discover?status=${status}${workspaceId ? `&workspaceId=${encodeURIComponent(workspaceId)}` : ''}`,
    ),
  setStatus: (ids: string[], status: DiscoverStatus) =>
    api.post<{ updated: number }>(`${base}/discover/status`, { ids, status }),
}

/** "5 min ago", "3 h ago", "2 days ago" — waktu relatif singkat dalam bahasa Inggris. */
export function ago(ms: number, now = Date.now()): string {
  const m = Math.max(0, Math.round((now - ms) / 60_000))
  if (m < 1) return 'just now'
  if (m < 60) return `${m} min ago`
  const h = Math.round(m / 60)
  if (h < 24) return `${h} h ago`
  const d = Math.round(h / 24)
  return `${d} ${d === 1 ? 'day' : 'days'} ago`
}
